export const ProductQueryProps = `
    items {
        display_name
        product_id
        product_url
        tags {
            total
            items {
                id
            }
        }
        short_description
        skus {
            total
            items {
                prices {
                    currency
                    is_discounted
                    include_tax {
                        original_price
                        price
                        price_formatted
                        price_per_unit
                    }
                }
                sizes {
                    key
                    value
                }
                shades {
                    name
                    hex_val
                    description
                }
                media {
                    small {
                        src
                        alt
                    }
                    medium {
                        src
                        alt
                    }
                    large {
                        src
                        alt
                    }
                }
                sku_badge
                sku_id
                inventory_status
            }
        }
    }
`;
